import { BrowserRouter } from 'react-router-dom';
import MainRouter from './routes';

function Root() {
  return (
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  );
}

export default Root;
